import { action, fsa } from "ts-action";
import {
  IS_FETCHING_PERSONALIZATION,
  RECEIVE_SERVER_PERSONALIZATION,
  RESTORE_DEFAULT_COLORS,
  SET_COLORS,
  UPDATE_PERSONALIZATION,
  UPDATE_PERSONALIZATION_HAS_ERROR,
  UPDATE_PERSONALIZATION_INFO,
  UPDATE_PERSONALIZATION_STATE,
  UPDATE_PERSONALIZATION_TITLE,
} from "./actionTypes";
import { PersonalizationDataForm } from "../../requests/personalization/types";
import { Colors, PersonalizationReducerState } from "./types";

export const setColors = action(
  SET_COLORS,
  fsa<{
    newColors: Colors;
  }>()
);

export const restoreDefaultColors = action(RESTORE_DEFAULT_COLORS, fsa<void>());

export const receiveServerPersonalization = action(
  RECEIVE_SERVER_PERSONALIZATION,
  fsa<{
    personalizationData: PersonalizationDataForm;
  }>()
);

export const updatePersonalization = action(
  UPDATE_PERSONALIZATION,
  fsa<{
    updatedData: PersonalizationReducerState;
  }>()
);

export const updatePersonalizationTitle = action(
  UPDATE_PERSONALIZATION_TITLE,
  fsa<{
    newTitle: string;
    localization: string;
  }>()
);

export const updatePersonalizationInfo = action(
  UPDATE_PERSONALIZATION_INFO,
  fsa<{
    newInfo: string;
    localization: string;
  }>()
);

export const isPersonalizationFetching = action(
  IS_FETCHING_PERSONALIZATION,
  fsa<{ flag: boolean }>()
);

export const updatePersonalizationState = action(
  UPDATE_PERSONALIZATION_STATE,
  fsa<{ state: boolean }>()
);

export const updatePersonalizationHasError = action(
  UPDATE_PERSONALIZATION_HAS_ERROR,
  fsa<{ hasError: boolean }>()
);
